var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 10.4961H18.375C18.2719 10.4961 18.1875 10.5805 18.1875 10.6836V18.1836H2.8125V2.80859H10.3125C10.4156 2.80859 10.5 2.72422 10.5 2.62109V1.30859C10.5 1.20547 10.4156 1.12109 10.3125 1.12109H1.875C1.46016 1.12109 1.125 1.45625 1.125 1.87109V19.1211C1.125 19.5359 1.46016 19.8711 1.875 19.8711H19.125C19.5398 19.8711 19.875 19.5359 19.875 19.1211V10.6836C19.875 10.5805 19.7906 10.4961 19.6875 10.4961Z",
    fill: "#C97A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84125 11.0328L6.79672 13.8195C6.79438 14.0281 6.96313 14.1992 7.17172 14.1992H7.1811L9.94672 14.1312C9.9936 14.1289 10.0405 14.1102 10.0733 14.0773L19.8209 4.35078C19.8936 4.27812 19.8936 4.15859 19.8209 4.08594L16.9077 1.175C16.8702 1.1375 16.8233 1.12109 16.7741 1.12109C16.7248 1.12109 16.678 1.13984 16.6405 1.175L6.89516 10.9016C6.86131 10.937 6.84205 10.9838 6.84125 11.0328ZM8.32953 11.5859L16.7741 3.16016L17.8334 4.21719L9.38422 12.6477L8.31313 12.6734L8.32953 11.5859Z",
    fill: "#C97A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/Form.614003641b4641a56d5b7f981bc47423.svg";
export { ForwardRef as ReactComponent };